export const translations = {
  en: {
    // Global
    'app.back': 'Back',
    'nav.search': 'Search',
    'nav.papers': 'Papers',
    'lang.english': 'English',
    'lang.hindi': 'Hindi',
    'lang.select_title': 'Choose your language',
    'lang.select_sub': 'You can change it anytime from the header.',
    'lang.continue': 'Continue',

    // HomePage
    'home.title': 'Woom ',
    'home.subtitle': 'Discover, analyze, and understand research papers with the power of AI. Enter a topic or question to find relevant academic papers and get instant insights.',
    'home.stats.papers': 'Papers',
    'home.stats.analysis': 'Analysis',
    'home.stats.free': 'Access',
    'home.features.title': 'Why Choose Woom?',

    // SearchBar
    'search.heading': 'Discover Research Papers',
    'search.subheading': 'Find and analyze academic papers with AI-powered insights',
    'search.placeholder': 'Enter your research topic or question...',
    'search.button': 'Search Papers',
    'search.loading': 'Searching...',
    'search.transcribing': 'Transcribing...',
    'search.popular': 'Popular searches:',
    'search.noTerm': 'Please enter a search term',
    'search.noResults': 'No papers found for your search. Try different keywords.',
    'search.fail': 'Failed to search papers. Please try again.',

    // ResearchPapers
    'papers.header': 'Research Papers',
    'papers.found': 'Found {count} papers matching your search',
    'papers.loading': 'Loading paper...',
    'papers.error': 'Failed to load paper. Please try again.',
    'papers.analyze': 'Analyze with AI',
    'papers.viewOriginal': 'View Original',
    'papers.noResults': 'No papers found',
    'papers.tryAgain': 'Try searching with different keywords',

    // PDFViewer (UI chrome)
    'pdf.tabs.analysis': 'Text Analysis',
    'pdf.tabs.chat': 'Chatbot',
    'pdf.analysis.selectTitle': 'Selected Text:',
    'pdf.analysis.loading': 'Analyzing...',
    'pdf.analysis.selectPrompt': 'Highlight any text in the PDF to get AI-powered analysis and insights.',
    'pdf.chat.startTitle': 'Start a Conversation',
    'pdf.chat.startDesc': 'Ask questions about the document content.',
    'pdf.chat.aiThinking': 'AI is thinking...',
    'pdf.chat.placeholder': 'Ask a question about the document...',
    'pdf.podcast.on': 'Podcast: On',
    'pdf.podcast.off': 'Podcast: Off',
    'pdf.podcast.hi.on': 'Podcast (हिंदी): On',
    'pdf.podcast.hi.off': 'Podcast (हिंदी): Off',

    // Features
    'feature.smartSearch.title': 'Smart Search',
    'feature.smartSearch.desc': 'Find relevant papers using AI-powered semantic search across thousands of research papers.',
    'feature.aiAnalysis.title': 'AI Analysis',
    'feature.aiAnalysis.desc': 'Get intelligent analysis and contextual explanations of complex research concepts and methodologies.',
    'feature.pdfViewer.title': 'PDF Viewer',
    'feature.pdfViewer.desc': 'Interactive PDF viewer with text selection and real-time analysis capabilities.',
    'feature.aiChat.title': 'AI Chatbot',
    'feature.aiChat.desc': 'Ask questions about any paper and get instant, intelligent responses from our AI assistant.',
    'feature.fast.title': 'Fast Processing',
    'feature.fast.desc': 'Quick paper loading and analysis with optimized performance for seamless user experience.',
    'feature.secure.title': 'Secure Access',
    'feature.secure.desc': 'Safe and secure access to research papers with privacy-focused design and data protection.',
  },
  hi: {
    // Global
    'app.back': 'वापस ',
    'nav.search': 'खोज',
    'nav.papers': 'पेपर',
    'lang.english': 'अंग्रेज़ी',
    'lang.hindi': 'हिन्दी',
    'lang.select_title': 'अपनी भाषा चुनें',
    'lang.select_sub': 'आप इसे कभी भी हेडर से बदल सकते हैं।',
    'lang.continue': 'जारी रखें',

    // HomePage
    'home.title': 'रीसर्च',
    'home.subtitle': 'AI की शक्ति के साथ शोध पत्र खोजें, विश्लेषण करें और समझें। प्रासंगिक अकादमिक पेपर खोजने और त्वरित इनसाइट्स पाने के लिए कोई विषय या प्रश्न दर्ज करें।',
    'home.stats.papers': 'पेपर',
    'home.stats.analysis': 'विश्लेषण',
    'home.stats.free': 'नि:शुल्क',
    'home.features.title': 'क्यों चुनें woom?',

    // SearchBar
    'search.heading': 'रीसर्च पेपर खोजें',
    'search.subheading': 'AI-सक्षम इनसाइट्स के साथ अकादमिक पेपर ढूंढें और विश्लेषण करें',
    'search.placeholder': 'अपना विषय या सवाल दर्ज करें...',
    'search.button': 'पेपर खोजें',
    'search.loading': 'खोज जारी…',
    'search.transcribing': 'ट्रांसक्राइब हो रहा है…',
    'search.popular': 'लोकप्रिय खोजें:',
    'search.noTerm': 'कृपया खोज शब्द दर्ज करें',
    'search.noResults': 'आपकी खोज के लिए कोई पेपर नहीं मिला। अलग कीवर्ड आज़माएँ।',
    'search.fail': 'पेपर खोजने में विफल। कृपया पुनः प्रयास करें।',

    // ResearchPapers
    'papers.header': 'रीसर्च पेपर',
    'papers.found': '{count} पेपर मिले',
    'papers.loading': 'पेपर लोड हो रहा है…',
    'papers.error': 'पेपर लोड करने में विफल। पुनः प्रयास करें।',
    'papers.analyze': 'AI से विश्लेषण करें',
    'papers.viewOriginal': 'मूल देखें',
    'papers.noResults': 'कोई पेपर नहीं मिला',
    'papers.tryAgain': 'अलग कीवर्ड के साथ खोजें',

    // PDFViewer (UI chrome)
    'pdf.tabs.analysis': 'पाठ विश्लेषण',
    'pdf.tabs.chat': 'चैटबॉट',
    'pdf.analysis.selectTitle': 'चुना हुआ पाठ:',
    'pdf.analysis.loading': 'विश्लेषण हो रहा है…',
    'pdf.analysis.selectPrompt': 'AI-संचालित विश्लेषण के लिए PDF में कोई भी पाठ हाइलाइट करें।',
    'pdf.chat.startTitle': 'संवाद शुरू करें',
    'pdf.chat.startDesc': 'दस्तावेज़ की सामग्री के बारे में प्रश्न पूछें।',
    'pdf.chat.aiThinking': 'AI सोच रहा है…',
    'pdf.chat.placeholder': 'दस्तावेज़ के बारे में अपना प्रश्न लिखें…',
    'pdf.podcast.on': 'पॉडकास्ट: चालू',
    'pdf.podcast.off': 'पॉडकास्ट: बंद',
    'pdf.podcast.hi.on': 'पॉडकास्ट (हिंदी): चालू',
    'pdf.podcast.hi.off': 'पॉडकास्ट (हिंदी): बंद',

    // Features
    'feature.smartSearch.title': 'स्मार्ट खोज',
    'feature.smartSearch.desc': 'हज़ारों शोध पत्रों में AI-संचालित सिमेंटिक खोज से प्रासंगिक पेपर ढूंढें।',
    'feature.aiAnalysis.title': 'AI विश्लेषण',
    'feature.aiAnalysis.desc': 'जटिल शोध अवधारणाओं और कार्यप्रणालियों की बुद्धिमान व्याख्या और संदर्भित स्पष्टीकरण प्राप्त करें।',
    'feature.pdfViewer.title': 'PDF व्यूअर',
    'feature.pdfViewer.desc': 'टेक्स्ट चयन और वास्तविक समय विश्लेषण क्षमताओं के साथ इंटरैक्टिव PDF व्यूअर।',
    'feature.aiChat.title': 'AI चैटबॉट',
    'feature.aiChat.desc': 'किसी भी पेपर के बारे में प्रश्न पूछें और तुरंत, बुद्धिमान उत्तर प्राप्त करें।',
    'feature.fast.title': 'तेज़ प्रोसेसिंग',
    'feature.fast.desc': 'बेहतर प्रदर्शन के साथ तेज़ पेपर लोडिंग और विश्लेषण।',
    'feature.secure.title': 'सुरक्षित पहुँच',
    'feature.secure.desc': 'गोपनीयता-केंद्रित डिजाइन और डेटा सुरक्षा के साथ सुरक्षित पहुँच।',
  }
};


